import React, { useContext, useState } from 'react'
import {
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Divider,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	TextField,
} from '@mui/material'
import { SportsScore, EmojiEvents, Edit } from '@mui/icons-material'
import { MonopolyContext } from '../../../contexts/MonopolyContext'
import { ref, runTransaction } from 'firebase/database'

const Receive = ({ users, myUserId, roomCode, setDrawer }) => {
	const { db, M } = useContext(MonopolyContext),
		[loading, setLoading] = useState(false),
		[custom, setCustom] = useState(false),
		[customAmount, setCustomAmount] = useState(''),
		askCustomAmount = _ => {
			setCustom(true)
			setCustomAmount('')
		},
		[error, setError] = useState(false),
		amounts = [
			{ value: 10 },
			{ value: 25 },
			{ value: 50 },
			{ value: 100 },
			{ value: 200 },
		],
		receive = reason => {
			console.log(reason)
			if (loading) return
			setLoading(true)
			runTransaction(ref(db, `lobbies/${roomCode}`), post => {
				if (post) {
					const amount =
							reason === 'go1' ? 200 : reason === 'go2' ? 400 : +reason,
						time = new Date().valueOf()
					if (!post.history) {
						post.history = []
					}
					post.history.push({
						time,
						amount,
						action: `received${
							reason === 'go1' ? 'ByGo1' : reason === 'go2' ? 'ByGo2' : ''
						}`,
						user: myUserId,
					})
					// update my user
					if (!post.users[myUserId].balance) {
						post.users[myUserId].balance = 0
					}
					post.users[myUserId].balance += amount
					if (!post.users[myUserId].history) {
						post.users[myUserId].history = []
					}
					post.users[myUserId].history.push({
						time,
						amount,
						action: 'receive',
						from: 'bank',
						reason: reason,
					})
					setDrawer(false)
				}
				setLoading(false)
				return post
			})
		}

	return (
		<>
			<Dialog
				open={custom}
				aria-labelledby='alert-dialog-title'
				aria-describedby='alert-dialog-description'>
				<DialogTitle id='alert-dialog-title'>
					Receive <M />
				</DialogTitle>
				<DialogContent>
					<TextField
						InputProps={{ style: { letterSpacing: '.1em' } }}
						autoFocus
						required
						variant='standard'
						label='Amount'
						error={!!error}
						helperText={error ? error : `How much do you receive?`}
						onChange={e => {
							let value = e.target.value
							value = value.replace(/\D/, '').substr(0, 6)
							if (value <= 0) {
								setError(`Please type in an amount.`)
							} else {
								setError(false)
							}
							setCustomAmount(value)
						}}
						pattern='\d+'
						value={customAmount}
						maxLength='6'
						name='amount'
						id='amount'
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={_ => setCustom(false)}>Cancel</Button>
					<Button
						disabled={!!error || loading || customAmount < 1}
						color='red'
						variant='contained'
						onClick={_ => receive(customAmount)}>
						Receive {customAmount} <M />
					</Button>
				</DialogActions>
			</Dialog>
			<List>
				<ListItem button='true' key=':custom' onClick={_ => askCustomAmount()}>
					<ListItemIcon>
						<Edit />
					</ListItemIcon>
					<ListItemText>
						Receive <b>custom value</b>
					</ListItemText>
				</ListItem>
				<Divider />
				<ListItem button='true' key=':go1' onClick={_ => receive('go1')}>
					<ListItemIcon>
						<SportsScore />
					</ListItemIcon>
					<ListItemText>
						I passed <b>‹GO›</b> (200 <M />)
					</ListItemText>
				</ListItem>
				<ListItem button='true' key=':go2' onClick={_ => receive('go2')}>
					<ListItemIcon>
						<SportsScore />
					</ListItemIcon>
					<ListItemText>
						I passed <b>‹GO›</b> (400 <M />)
					</ListItemText>
				</ListItem>
				<Divider />
				{amounts.map(amount => (
					<ListItem
						button='true'
						key={amount.value}
						onClick={_ => receive(amount.value)}>
						<ListItemIcon>
							<EmojiEvents />
						</ListItemIcon>
						<ListItemText>
							I receive {amount.value} <M />
						</ListItemText>
					</ListItem>
				))}
			</List>
		</>
	)
}

export default Receive
